module.exports = __webpack_public_path__ + "static/media/sj.af474213.webp";